/**
 * Asset Categories API
 * Handles all asset category-related API calls
 */
import apiClient from './apiClient';
import {
  AssetCategory,
  AssetCategoriesListResponse,
  CreateAssetCategoryData,
  UpdateAssetCategoryData,
} from '../types';

export interface AssetCategoriesQueryParams {
  include_inactive?: boolean;
}

export const assetCategoriesApi = {
  /**
   * Get all asset categories
   */
  getCategories: async (params?: AssetCategoriesQueryParams): Promise<AssetCategoriesListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.include_inactive) queryParams.append('include_inactive', 'true');

    const query = queryParams.toString();
    return apiClient.get<AssetCategoriesListResponse>(`/asset-categories${query ? `?${query}` : ''}`);
  },

  /**
   * Get a specific category by ID
   */
  getCategory: async (categoryId: number): Promise<{ category: AssetCategory }> => {
    return apiClient.get<{ category: AssetCategory }>(`/asset-categories/${categoryId}`);
  },

  /**
   * Create a new category
   */
  createCategory: async (data: CreateAssetCategoryData): Promise<{ message: string; category: AssetCategory }> => {
    return apiClient.post<{ message: string; category: AssetCategory }>('/asset-categories', data);
  },

  /**
   * Update an existing category
   */
  updateCategory: async (
    categoryId: number,
    data: UpdateAssetCategoryData
  ): Promise<{ message: string; category: AssetCategory }> => {
    return apiClient.put<{ message: string; category: AssetCategory }>(`/asset-categories/${categoryId}`, data);
  },

  /**
   * Delete (soft delete) a category
   */
  deleteCategory: async (categoryId: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/asset-categories/${categoryId}`);
  },
};

export default assetCategoriesApi;
